// Core imports
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';

// Import axios
import './plugins/axios';
import './registerServiceWorker';

// Global styles
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'leaflet';
window.Buffer = window.Buffer || require('buffer').Buffer;

// Plugins
// import VueAxios from 'vue-axios';
import AuthPlugin from './plugins/authentication';
import offline from './plugins/offline';
import TokenExpiryPlugin from './plugins/tokenExpiry';
import LoadingHelper from './plugins/loadingHelper';
import getEncode from './plugins/getEncode';
import { translit, hasCyrillic } from './plugins/transliteration';

// Global components
import errorMessage from './components/ErrorMessage';

// Vue config
Vue.config.productionTip = false;

// Add custom Custom properties for transliteration service
Vue.prototype.$translit = translit;
Vue.prototype.$hasCyrillic = hasCyrillic;

// Plugin usage// Install authentication plugin BEFORE creating Vue instance
Vue.use(AuthPlugin, { store, router, $axios: Vue.prototype.$axios });
Vue.use(TokenExpiryPlugin);

// Vue.use(Auth, { store, router });
Vue.use(offline);
Vue.use(getEncode);
Vue.use(LoadingHelper);
Vue.component('errorMessage', errorMessage);
// Vue.use(VueAxios, { $axios: axios });

// App mounting
new Vue({
  components: {
    errorMessage,
  },
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

// Optional: Add global error handler for auth errors
window.addEventListener('authError', (event) => {
  const { type, error } = event.detail;
  console.error('Auth Error:', type, error);

  // You can handle different error types here
  if (type === 'refresh-failed') {
    // Show user-friendly message
    // Maybe redirect to login
  }
});
